module.exports = __webpack_public_path__ + "static/media/zoho-logo-web.1a00f3e5.png";